export interface CollaborationCursor {
  x: number;
  y: number;
}

export interface CollaborationPresence {
  cursor: CollaborationCursor | null;
  selectedRowId: string | null;
  activeField: string | null;
}

export interface CollaborationUserMeta {
  name: string;
  color: string;
  avatarFallback: string;
}

export const COLLABORATOR_COLORS = [
  'var(--ds-color-data-viz-1)',
  'var(--ds-color-data-viz-2)',
  'var(--ds-color-data-viz-3)',
  'var(--ds-color-data-viz-4)',
  'var(--ds-color-data-viz-5)',
];

export function createAvatarFallback(name: string): string {
  const tokens = name.trim().split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return '?';
  if (tokens.length === 1) return tokens[0].slice(0, 2).toUpperCase();
  return `${tokens[0][0] ?? ''}${tokens[tokens.length - 1][0] ?? ''}`.toUpperCase();
}

export function createCollaborator(roomKey: string): CollaborationUserMeta {
  const randomPart = Math.abs(hashString(roomKey));
  const humanIndex = (randomPart % 97) + 1;
  const name = `Collaborator ${humanIndex}`;

  return {
    name,
    color: COLLABORATOR_COLORS[randomPart % COLLABORATOR_COLORS.length],
    avatarFallback: createAvatarFallback(name),
  };
}

function hashString(input: string): number {
  let hash = 0;
  for (let index = 0; index < input.length; index += 1) {
    hash = ((hash << 5) - hash) + input.charCodeAt(index);
    hash |= 0;
  }
  return hash;
}

export function getCollaboratorColor(seed: string | number): string {
  const index = Math.abs(hashString(String(seed))) % COLLABORATOR_COLORS.length;
  return COLLABORATOR_COLORS[index];
}
